export default __webpack_public_path__ + "5e24a4d6e6b01eec34f9919e291e245d.webp";